import { render, staticRenderFns } from "./ArticleLatestHeadlinesSection.vue?vue&type=template&id=3aafefe8&scoped=true"
import script from "./ArticleLatestHeadlinesSection.vue?vue&type=script&lang=ts"
export * from "./ArticleLatestHeadlinesSection.vue?vue&type=script&lang=ts"
import style0 from "./ArticleLatestHeadlinesSection.vue?vue&type=style&index=0&id=3aafefe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafefe8",
  null
  
)

export default component.exports